import React from 'react';
import { StarIcon } from 'lucide-react';
export const StickyCTA = ({
  showNewImage = false
}) => {
  return <div className="sticky-cta" data-id="element-399">
      <div className="sticky-cta-inner" data-id="element-400">
        <h3 className="text-xl font-bold text-center mb-3 text-gray-900" data-id="element-401">
          Instant Neck Relief or Money Back!
        </h3>
        <div className="product-image mb-4 bg-gray-100 rounded-lg overflow-hidden" data-id="element-402">
          <div className="aspect-w-1 aspect-h-1 relative w-full" style={{
          paddingBottom: '100%'
        }} data-id="element-403">
            <div className="absolute inset-0 flex flex-col items-center justify-center p-4 text-center" data-id="element-404">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/w3s34g3Qod74z4uPR4ShK3/ChatGPT_Image_11_%CE%9D%CE%BF%CE%B5_2025%2C_09_20_17_%CE%BC.%CE%BC..png" alt="RejuvaNeck Device in use with EMS technology" className="object-contain h-full w-full" data-id="element-405" />
            </div>
          </div>
        </div>
        <div className="customer-reviews mb-4" data-id="element-406">
          <div className="flex items-center justify-center mb-1" data-id="element-407">
            <div className="flex" data-id="element-408">
              {[1, 2, 3, 4, 5].map((star, index) => <StarIcon key={index} className={`h-5 w-5 ${index < 5 ? 'text-yellow-400' : 'text-gray-300'} fill-current`} data-id="element-409" />)}
            </div>
            <span className="ml-2 text-sm font-semibold" data-id="element-410">4.9 out of 5</span>
          </div>
          <p className="text-center text-sm text-gray-600" data-id="element-411">
            1,672 customer ratings
          </p>
        </div>
        <div className="ratings-breakdown mb-4 px-2" data-id="element-412">
          {[{
          label: '5★',
          percentage: 92
        }, {
          label: '4★',
          percentage: 6
        }, {
          label: '3★',
          percentage: 1
        }, {
          label: '2★',
          percentage: 1
        }, {
          label: '1★',
          percentage: 0
        }].map((rating, index) => <div key={index} className="flex items-center text-sm mb-1" data-id="element-413">
              <span className="w-8" data-id="element-414">{rating.label}</span>
              <div className="flex-1 mx-2 bg-gray-200 rounded-full h-2.5" data-id="element-415">
                <div className="bg-yellow-400 h-2.5 rounded-full" style={{
              width: `${rating.percentage}%`
            }} data-id="element-416"></div>
              </div>
              <span className="w-8 text-right" data-id="element-417">{rating.percentage}%</span>
            </div>)}
        </div>
        <a href="https://thegliserastore.com/pages/glisera-sales-page" className="bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-4 rounded-lg shadow-md transition-all w-full uppercase tracking-wider text-center mb-2 block" data-id="element-418">
          CHECK AVAILABILITY →
        </a>
        <p className="text-xs text-center text-gray-500" data-id="element-419">
          Limited time offer - Fast FREE shipping across the US
        </p>
      </div>
    </div>;
};